import { Component, inject } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import { MatToolbar } from '@angular/material/toolbar';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
    templateUrl: 'dirty-dialog.component.html',
    styleUrls: ['dirty-dialog.component.scss'],
    imports: [MatToolbar, MatIcon, MatButton]
})
export class DirtyDialogComponent {
  dialogRef = inject<MatDialogRef<DirtyDialogComponent>>(MatDialogRef);


  onLeave() {
    this.dialogRef.close(true);
  }

  onStay() {
    this.dialogRef.close(false);
  }
}
